import { Component } from '@builder.io/sdk';
import { tabsConfig } from '@builder.io/widgets/dist/lib/components/Tabs.config';

export const config: Component = tabsConfig;
